import { Modal } from "antd";
import React, { CSSProperties } from "react";

import { CloseOutlined } from "@ant-design/icons";

import styles from "./index.module.css";

type Props = {
  children: React.ReactElement;
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  style?: CSSProperties;
  title: React.ReactNode;
  is24padding?: boolean;
};

export const ModalComponentV1 = ({ children, isOpen, onClose, title, className, style, is24padding }: Props) => {
  return (
    <div className={styles.wrapperModal}>
      <Modal
        title={title}
        open={isOpen}
        afterClose={onClose}
        onCancel={onClose}
        className={`${className ?? ""} ${styles.modal} ${is24padding ? styles.padding24 : ""}`}
        footer={false}
        style={style}
        closeIcon={<CloseOutlined style={{ fontSize: 14, color: "#000" }} />}
      >
        {children}
      </Modal>
    </div>
  );
};
